<template>
  <l-map
    ref="map"
    :center="center0"
    :zoom="zoom0"
    class="shipmap"
    :options="options"
  >
    <l-tile-layer :url="mapUrl" />
    <l-polyline
      v-for="(pointChunk, index) in chunks"
      :key="index"
      :lat-lngs="pointChunk.points"
      :color="pointChunk.color"
    />
  </l-map>
</template>

<script>
import { LMap, LTileLayer, LPolyline, LCircleMarker } from 'vue2-leaflet'

import { latLng } from 'leaflet'

import 'leaflet/dist/leaflet.css'

import { div } from './maputil'

export default {
  name: 'ShipMap',

  components: {
    LMap,
    LTileLayer,
    LPolyline,
    LCircleMarker,
  },

  props: {
    zoom: {
      type: Number,
      default: 2,
    },

    center: {
      type: Array,
      default: () => [0, 0],
    },

    points: {
      type: Array,
      default: () => [],
    },
  },

  data() {
    return {}
  },

  computed: {
    mapUrl() {
      return 'https://map.freightower.com/vt?lyrs=m@189&gl=cn&hl=zh-CN&x={x}&y={y}&z={z}'
    },

    options() {
      return {
        zoomControl: false,
      }
    },

    center0: {
      get() {
        return this.center
      },

      set(value) {
        this.$emit('update:center', value)
      },
    },

    zoom0: {
      get() {
        return this.zoom
      },

      set(value) {
        this.$emit('update:zoom', value)
      },
    },

    chunks() {
      const chunks = this.points || []

      return chunks.map(chunk => {
        let dir = 0

        for (let j = 1; j < chunk.points.length; j++) {
          const point = chunk.points[j],
            lastPoint = chunk.points[j - 1]

          if (Math.abs(div(point.lon) - div(lastPoint.lon)) > 180) {
            dir = point.lon < 0 ? 1 : -1
            break
          }
        }

        const points = chunk.points.map(point => {
          const lon = div(point.lon),
            lat = div(point.lat)

          return latLng(
            lat,
            Math.abs(dir + lon) < Math.abs(lon) ? lon + dir * 360 : lon
          )
        })

        return Object.assign({}, chunk, {
          points,
        })
      })
    },
  },

  watch: {
    chunks() {
      this.$nextTick(() => {
        const chunks = this.chunks
        if (chunks.length && chunks[0].length) {
          this.$refs.map.mapObject.panTo(chunks[0][0])
        }
      })
    },
  },
}
</script>

<style scoped lang="scss"></style>
